import { FC, ReactNode, useCallback } from 'react';
import { useForm, FormProvider, FormState } from 'react-hook-form';
import { Grid, Stack } from '@mui/material';

import { ObjectivesFieldForm } from './ObjectiveFieldForm';


export type FormData = Partial<Users.Preferences>

interface Props {
    onSubmitRequest: (values: FormData) => void;
    onFieldChange?: (fieldName: string, value: any) => void;
    slots?: {
      footer?: ReactNode | ((formState: FormState<FormData>) => ReactNode);
    }
    defaultValues?: Partial<FormData>;
};

const DEFAULT_VALUES: Partial<FormData> = {
  communicationObjective1: '',
  communicationObjective2: '',
  communicationObjective3: '',
};

export const ObjectivesForm: FC<Props> = (props) => {
  const { onSubmitRequest, slots, defaultValues = DEFAULT_VALUES, onFieldChange } = props;

  const methods = useForm<FormData>({
    mode: 'onBlur',
    defaultValues: {
      ...DEFAULT_VALUES,
      ...defaultValues,
    },
  });

  const { handleSubmit, formState } = methods;

  const onSubmit = useCallback(async (data: FormData) => {
    const payload = {
      ...data,
    };

    return onSubmitRequest(payload);
  }, [onSubmitRequest]);

  const hints = [
    'Be specific and actionable',
    'Focus on measurable outcomes',
    'Think about stakeholder impact',
  ];

  const placeholders = [
    'e.g., Align leadership team on strategic vision for 2024',
    'e.g., Improve cross-functional collaboration by 40%',
    'e.g., Enhance investor confidence through quarterly presentations',
  ];

  const suggestions = [
    'Align leadership team on strategic vision',
    'Improve cross-functional collaboration',
    'Enhance stakeholder communication',
    'Drive organizational change initiatives',
  ];

  return (
    <FormProvider {...methods}>
      <form style={{ width: '100%', height: '100%' }} onSubmit={handleSubmit(onSubmit)}>
        <Stack justifyContent="space-between" height="100%" gap={4}>
          <Grid container spacing={3} mt={2}>
            {Array.from({ length: 3 }).map((_, index) => (
              <ObjectivesFieldForm
                index={index}
                key={index}
                fieldPath={`communicationObjective${index + 1}`}
                placeholder={placeholders[index]}
                hint={hints[index]}
                suggestions={suggestions}
                onFieldChange={onFieldChange}
              />
            ))}

            <Grid size={12}>
              {typeof slots?.footer === 'function' ? slots?.footer(formState) : slots?.footer}
            </Grid>
          </Grid>

        </Stack>
      </form>
    </FormProvider>
  );
};
